import { render, staticRenderFns } from "./Configure.vue?vue&type=template&id=5c6bb725&scoped=true&"
import script from "./Configure.vue?vue&type=script&lang=js&"
export * from "./Configure.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c6bb725",
  null
  
)

export default component.exports